import { ValueRegistryItem } from '../../../registry/value/ValueRegistryItem';
import { ValueRegistryCategory } from '../../../registry/value/ValueRegistryCategory';
export class ValuesKnowAWord extends ValueRegistryCategory {
    label = 'Question KnowAWord';
    constructor(parent) {
        super(parent);
        super.init();
    }
    wordTaskInputAutoWidth = () => new ValueRegistryItem({
        label: 'Auto Input Width',
        value: context => {
            if (!context.wordTask)
                return 200;
            return (context.at.local.valueOf.scaleFactor * context.wordTask.wordTaskForm.inputAutoWidth +
                context.wordTask.ownAspect.input.valueOf.paddingLeft +
                context.wordTask.ownAspect.input.valueOf.paddingRight);
        },
        params: { core: ['scaleFactor'] },
    });
    wordTaskInputAutoSize = () => new ValueRegistryItem({
        label: 'Auto Input Size (Widest Correct input)',
        value: context => {
            if (!context.wordTask)
                return 5;
            return context.wordTask.wordTaskForm.inputAutoSize;
        },
    });
    wordTaskInputAutoFontSize = () => new ValueRegistryItem({
        label: 'Auto Input Font Size',
        value: context => {
            if (!context.wordTask)
                return 26;
            return context.wordTask.wordTaskForm.inputAutoFontSize;
        },
    });
    wordTaskNearestWordingString = () => new ValueRegistryItem({
        label: 'Nearest Wording/Solution to current input',
        value: context => {
            if (!context.wordTask)
                return '';
            return context.wordTask.wordTaskNearest.revealString;
        },
    });
    wordTaskInputValueDisplayed = () => new ValueRegistryItem({
        value: context => {
            if (!context.wordTask)
                return '';
            return context.wordTask.wordTaskInput.inputValueDisplayed;
        },
    });
}
